export default __webpack_public_path__ + "static/media/no-sensitivity.d0f2a1a5.svg";